'use client';

import { Box } from '@mantine/core';
import { FormComponent } from './FormComponent';
import { RootBox } from '@/shared/RootBox';
import { SectionTitle } from '@/shared/SectionTitle';
import { useInView } from 'react-intersection-observer';
import { setSelectedPage } from '@/features/menuLinks/menuLinksSlice';
import { SelectedPage } from '@/types/types';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import { useEffect, useState } from 'react';
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline';

type Props = {};

export const ContactUs = (props: Props) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const dispatch = useAppDispatch();
  const [formState, setformState] = useState<string>('notSubmitted');

  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      dispatch(setSelectedPage(SelectedPage.RequestAFreeTrial));
    }
  }, [inView, dispatch]);

  const handleFormSubmit = (status: string) => {
    setformState(status);
  };

  return (
    <Box id="contactus" ref={ref} className="h-full w-full">
      <RootBox>
        <SectionTitle title="Contact Us" index={4} />
        <Box className="mb-20 mt-12 flex h-full w-full justify-between xxs:max-md:mb-0 xxs:max-md:flex-col">
          <Box className="flex w-2/6 flex-col text-lg text-secondary-500 xxs:max-md:w-full dark:text-lightBlue-200">
            <Box className="mt-4 flex flex-col">
              <Box className="flex items-start gap-2">
                <p className="tracking-tight">
                  Experience how Arcanis Capital’s systematic platform identifies opportunities, simulates strategies, and optimizes portfolio outcomes.
                  Schedule a walkthrough or discuss partnership options for institutional LPs.

                </p>
              </Box>
            </Box>
          </Box>
          <Box className="ml-20 w-4/6 xxs:max-md:ml-0 xxs:max-md:mt-12 xxs:max-md:w-full">
            {formState === 'notSubmitted' && (
              <FormComponent onFormSubmit={handleFormSubmit} />
            )}
            {formState === 'submitted' && (
              <Box className="flex flex-col gap-2 text-lg">
                <p className="text-xl font-bold text-lightBlue-200">
                  Thank you!
                </p>
                <p className="text-lg text-lightBlue-500">
                  Your message has been sent. We will get back to you shortly.
                </p>
              </Box>
            )}
            {formState === 'error' && (
              <Box className="flex flex-col gap-2 text-lg">
                <p className="text-xl font-bold text-lightBlue-500">Error!</p>
                <p className="text-lg text-lightBlue-500">
                  There was an error sending your message. Please try again
                  later.
                </p>
              </Box>
            )}
          </Box>
        </Box>
      </RootBox>
    </Box>
  );
};
